import { InjectionToken } from '@angular/core';
import type { RawEditorOptions } from 'tinymce';

/**
 * Where the self-hosted TinyMCE assets (skins, plugins) are served from, e.g.
 * `${blobBaseUrl}/tinymce`. The host app provides it once at the root.
 */
export const TINYMCE_BASE_URL = new InjectionToken<string>('TINYMCE_BASE_URL');

/** A compact editor: basic formatting, lists and links, no menu bar. */
export const RICH_TEXT_EDITOR_DEFAULTS: RawEditorOptions = {
  suffix: '.min',
  plugins: 'link lists',
  toolbar: 'bold italic underline | bullist numlist | link',
  menubar: false,
  toolbar_sticky: false,
  branding: false,
  promotion: false,
  elementpath: false,
  link_target_list: false,
  relative_urls: false,
  remove_script_host: false,
};
